export const gachaConfig = {
    maxDraws: 3,
    rarityRates: [
        { star: 3, threshold: 94.3 },
        { star: 4, threshold: 99.4 },
        { star: 5, threshold: 100 },
    ],
    media: {
        drawSound: '/sounds/ysck.mp3',
        resultSoundByStar: {
            3: '/sounds/4_star_effect.wav',
            4: '/sounds/4_star_effect.wav',
            5: '/sounds/4_star_effect.wav',
        },
        videoByStar: {
            3: '/videos/3starwish_ys_bm.mp4',
            4: '/videos/4starwish_ys_bm.mp4',
            5: '/videos/5starwish_ys_bm.mp4',
        },
    },
};
